export function replaceWithDynamicHost(
  url: string,
  apiHostMappings: {
    origin: string;
    apiHost: string;
  }[]
) {
  const originUrl = new URL(window.location.origin);
  const origin = originUrl.hostname;
  const currentOrigin = apiHostMappings?.find((x) => x.origin === origin);
  if (currentOrigin) {
    const currentUrl = new URL(url);
    currentUrl.hostname = currentOrigin?.apiHost;

    return currentUrl.toString();
  }

  return url;
}
